import {Deserializable} from '../../protocols/deserializable';
import {AssetSize} from '../../enum/dto/asset-size.enum';
import {ReplaySubject} from 'rxjs';
import {SafeResourceUrl} from '@angular/platform-browser';

export class AssetUrl implements Deserializable {
  public size: AssetSize;
  public url: string;
  // not from API
  public srcUrl: ReplaySubject<string | SafeResourceUrl>;
  public loading: ReplaySubject<boolean>;
  // Cache
  public urlAccessDate: number;

  public onDeserialize() {
    this.srcUrl = new ReplaySubject<string | SafeResourceUrl>(1);
    this.loading = new ReplaySubject<boolean>(1);
  }

}
